import { find, get } from 'lodash'
import { Maybe } from '@wix/wix-data-client-wix-code-adt'
import { isFieldReferencedOrNested } from './isFieldReferencedOrNested'
import {
  getReferenceFieldName,
  FIELD_PATH_SEPARATOR,
} from './referenceFieldPath'
import type { DigestedSchemaField } from '@wix/wix-data-client-common-standalone'

export const getFieldByFieldName = (
  fields: DigestedSchemaField[],
  fieldName: string,
) => find(fields, { name: fieldName })

export const getReferencedCollectionName = (
  fields: DigestedSchemaField[],
  fieldName: string,
) => {
  const field = getFieldByFieldName(fields, fieldName)
  return get(field, 'referencedCollection')
}

export const getFieldTypeByFieldName = (
  fields: DigestedSchemaField[],
  fieldName: string,
) => {
  const field = getFieldByFieldName(fields, fieldName)
  return get(field, 'type')
}

export const getReferencingField = (
  fields: DigestedSchemaField[],
  fieldName: string,
) => {
  if (!isFieldReferencedOrNested(fieldName)) {
    return Maybe.Nothing()
  }

  const referenceFieldName = getReferenceFieldName(fieldName)!
  return Maybe.fromNullable(getFieldByFieldName(fields, referenceFieldName))
}

export const getReferencedNestedRootFieldName = (fieldPath: string) =>
  getFieldParts(fieldPath).slice(0, 2).join(FIELD_PATH_SEPARATOR)

export const getNestedRootFieldName = (fieldPath: string) =>
  getFieldParts(fieldPath)[0]

export const getFieldParts = (fieldPath: string) =>
  fieldPath.split(FIELD_PATH_SEPARATOR)
